<kl-grid
  [columns]="[
    {
      header: 'document_type' | translate,
      binding: 'document_type',
      width: 150,
      translate: true,
      visible: true
    },
    {
      header: 'document_date' | translate,
      binding: 'document_date',
      format: 'date-time',
      width: 150,
      visible: true
    },
    {
      header: 'document_num' | translate,
      binding: 'document_num',
      width: 230,
      visible: true
    },
    {
      header: 'approval_status' | translate,
      binding: 'document_state',
      width: 190,
      translate: true,
      visible: true
    },
    {
      header: 'dealers_code' | translate,
      binding: 'current_account.code',
      width: 230,
      visible: true
    },
    {
      header: 'dealers_description' | translate,
      binding: 'current_account.description',
      width: 230,
      visible: true
    },
    {
      header: 'customer_code' | translate,
      binding: 'customer.code',
      width: 230,
      visible: true
    },
    {
      header: 'customer_description' | translate,
      binding: 'customer.description',
      width: 230,
      visible: true
    }
  ]"
  [filterable]="true"
  [deferResizing]="true"
  [tabId]="tabId || modalId"
  [service]="{
    service: 'virtual-order',
    name: 'virtual_order_receipts',
    form: 'VIRTUAL_ORDER_RECEIPT',
    showButton: true,
    showDropDownButton: true
  }"
  [parentModuleName]="'SHIPPING_MANAGEMENT'"
  [moduleName]="'VIRTUAL_ORDER_RECEIPT_LIST'"
  [gridName]="'grdVirtualOrderReceiptList'"
  [deleteOptions]="deleteOptions"
  [editOptions]="editOptions"
  [filterSelectItems]="filterSelectItems"
  [customFilter]="true"
  [customFilterOutlet]="'VIRTUAL_ORDER_RECEIPT_DETAIL_FILTER'"
>
</kl-grid>

<div
  class="modal fade"
  bsModal
  #designListModal="bs-modal"
  [config]="{ backdrop: false }"
  tabindex="-1"
  role="dialog"
  aria-labelledby="dialog-static-name"
>
  <div class="modal-dialog modal-sm" style="max-width: 45% !important">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-static-name2" class="modal-title pull-left">
          {{ "design_list" | translate }}
        </h4>
        <button
          type="button"
          class="close pull-right"
          aria-label="Close"
          (click)="designListModal.hide()"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <div class="grid-body">
          <wj-flex-grid
            #DesignListGrid
            [deferResizing]="false"
            [itemsSource]="designCollectionView"
            [isReadOnly]="designList.length === 0"
            [allowDelete]="true"
            [headersVisibility]="'Column'"
          >
            <wj-flex-grid-column
              [header]="'description' | translate"
              [isReadOnly]="true"
              [binding]="'description'"
              [width]="'*'"
            ></wj-flex-grid-column>
            <wj-flex-grid-column
              [header]="'processes' | translate"
              [isReadOnly]="true"
              [binding]="''"
              [width]="75"
            >
              <ng-template
                wjFlexGridCellTemplate
                [cellType]="'Cell'"
                let-cell="cell"
              >
                <button
                  type="button"
                  class="btn btn-sm btn-blue"
                  (click)="openDesigner('edit', cell.item)"
                >
                  <i class="fal fa-edit f-s-14"></i>
                </button>
                <button
                  type="button"
                  class="btn btn-sm btn-vodafone"
                  (click)="deleteDesign(cell.item)"
                >
                  <i class="fal fa-trash-alt f-s-14"></i>
                </button>
              </ng-template>
            </wj-flex-grid-column>
          </wj-flex-grid>
        </div>
      </div>
      <div class="modal-footer">
        <button
          type="button"
          (click)="openDesigner('add')"
          class="btn btn-sm btn-greenish"
          data-dismiss="modal"
        >
          <i class="fal fa-plus"></i> {{ "new_design" | translate }}
        </button>
        <button
          type="button"
          (click)="printLabel()"
          class="btn btn-sm btn-info"
          data-dismiss="modal"
        >
          <i class="fal fa-print"></i> {{ "print" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-default btn-sm"
          data-dismiss="modal"
          (click)="designListModal.hide()"
        >
          {{ "close" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
